import { on, reducer } from 'ts-action';
import * as ecgActions from '../../ecg/actions/ecg.actions';
import * as undoActions from '../../undo/actions/undo.actions';
import * as navigationActions from '../actions/navigation.actions';

export interface NavigationState {
  timestamp: number;
  offset: number;
  active: boolean;
}

declare module 'react-redux' {
  interface DefaultRootState {
    navigation: NavigationState;
  }
}

const initialStateFactory = (): NavigationState => ({
  timestamp: 0,
  offset: 0,
  active: false,
});

export default reducer(
  initialStateFactory(),
  on(
    navigationActions.go,
    navigationActions.setTimestamp,
    (state, { timestamp }): NavigationState => {
      return {
        ...state,
        timestamp,
      };
    },
  ),
  on(
    navigationActions.start,
    (state, { offset }): NavigationState => ({
      ...state,
      offset,
      active: true,
    }),
  ),
  on(
    navigationActions.stop,
    (state): NavigationState => ({
      ...state,
      offset: 0,
      active: false,
    }),
  ),
  on(ecgActions.clean, () => initialStateFactory()),
  on(
    undoActions.undo,
    undoActions.restore,
    (state, { diff: { navigation } }) => {
      if (!navigation) {
        return state;
      }
      return { ...state, ...navigation };
    },
  ),
);
